import React from 'react';
import type { SeasonType } from '../..';
import { SeasonDescriptor } from '../SeasonDescriptor';
import { SeasonalToggle } from '../SeasonalToggle';
import Styles from './styles.scss';

interface SeasonalPricingHeadingProps {
	selectedSeason: SeasonType;
	onChange: (season: SeasonType) => void;
}

export const SeasonalPricingHeading = ({
	selectedSeason,
	onChange,
}: SeasonalPricingHeadingProps) => {
	return (
		<div
			className={Styles.seasonalPricingHeading}
			data-testid="seasonal-pricing-heading"
		>
			<SeasonalToggle selectedSeason={selectedSeason} onChange={onChange} />
			<SeasonDescriptor selectedSeason={selectedSeason} />
		</div>
	);
};
